import { render, staticRenderFns } from "./ModalTimeError.vue?vue&type=template&id=b5f33c62&scoped=true"
import script from "./ModalTimeError.vue?vue&type=script&lang=js"
export * from "./ModalTimeError.vue?vue&type=script&lang=js"
import style0 from "./ModalTimeError.vue?vue&type=style&index=0&id=b5f33c62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f33c62",
  null
  
)

export default component.exports